
  <div dw-tooltip dwPlacement="topLeft" dwOverlayClassName="ag-invalid-cell-overlay"
       [dwTitle]="errorContent" [dwVisible]="errorVisible"
       *ngIf="errorVisible"></div>
  <ng-template #errorContent>
    <div *ngFor="let msg of validationMessages">{{ msg.key | translate:msg.params }}</div>
  </ng-template>
  <form [formGroup]="validateForm">
    <dw-form-control>
      <dw-input-group>
      <label
 dw-checkbox
  dw-checkbox
  [formControl]="formControl" [(ngModel)]="checked"  [(dwDisabled)]="disabled"></label>
      </dw-input-group>
    </dw-form-control>
  </form>
  